/* ****************************************************************************************************

  slider(slick)

**************************************************************************************************** */
jQuery(function($) {

  /* ======================================================================

    トップのOTHER

  ====================================================================== */
  if ($('#js-other-slide').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $otherSlide = $('#js-other-slide');
    var $otherSlideCont = $otherSlide.find('.s-other__inner');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $otherSlideCont.on('init', function() {
      $otherSlide.addClass('is-active');
    });
    $otherSlideCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: false,
      arrows: true,
      appendArrows: $otherSlide,
      focusOnSelect: true,
      prevArrow: '<div class="s-other__arrow s-other__arrow--prev"></div>',
      nextArrow: '<div class="s-other__arrow s-other__arrow--next"></div>',
      dots: true,
      dotsClass: 's-other__nav',
      customPaging: function(slick, index){
        return '<div class="s-other__dot"></div>';
      },
      autoplay: false,
      // autoplaySpeed: 5000,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            centerPadding: '0',
          }
        }
      ]
    });
  }// if ($('#js-home-slide').length)

});
